export type ValueFile = string | { file?: File, value: string }

export enum FILE_Field_ERROR {
  SIZE = 'SIZE',
  TYPE = 'TYPE',
  LOAD = 'LOAD'
}

export class ErrorFileField extends Error {
  type: FILE_Field_ERROR

  constructor(message: string, type: FILE_Field_ERROR) {
    super(message)
    this.type = type
  }
}
